module.exports = __webpack_public_path__ + "img/senalando-izqcr.png.73ff5cd9.webp";